<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="document-preview-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">{{ data.title }}</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div class="modal-content-body preview-dialog-body">
        <app-document-preview
          [base64ForDocument]="data.base64ForDocument"
          [extension]="data.extension"
          [height]="'calc(100vh - 220px)'">
        </app-document-preview>
      </div>
    </div>
  </div>
</div>
